import { useZoom } from '@/services/zoom/ZoomProvider';
import { useTwilio } from '@/services/twilio/TwilioProvider';
import { USE_TWILIO_VIDEO } from '@/shared/constants/flags';

/**
 * Unified hook that returns the appropriate video provider based on feature flag
 * Always calls both hooks to satisfy React's rules of hooks, but only returns the active one
 */
export const useVideoProvider = () => {
  const zoomContext = useZoom();
  const twilioContext = useTwilio();

  // Return the appropriate provider based on feature flag
  return USE_TWILIO_VIDEO ? twilioContext : zoomContext;
};
